module.exports = __webpack_public_path__ + "static/media/jack-form-header.d567cc34.webp";